var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9399 5.08584e-07C8.10339 -2.63932e-07 0.939945 7.16344 0.939945 16C0.939944 24.8366 8.10339 32 16.9399 32C25.7765 32 32.9399 24.8366 32.9399 16C32.9399 7.16344 25.7765 1.2811e-06 16.9399 5.08584e-07Z",
    fill: "#4C5064"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3084 12.039C19.5415 11.8086 19.6736 11.495 19.6755 11.1672C19.6775 10.8394 19.5491 10.5243 19.3187 10.2911C19.0883 10.0579 18.7747 9.92587 18.4469 9.92393C18.1191 9.92199 17.804 10.0503 17.5708 10.2808L12.7408 15.1108C12.5134 15.3428 12.386 15.6547 12.386 15.9795C12.386 16.3044 12.5134 16.6163 12.7408 16.8483L17.5708 21.6576C17.6822 21.783 17.8181 21.8843 17.9701 21.9552C18.122 22.0262 18.2869 22.0653 18.4546 22.0703C18.6222 22.0752 18.7891 22.0458 18.945 21.9839C19.1009 21.922 19.2425 21.8289 19.3611 21.7103C19.4797 21.5917 19.5728 21.4501 19.6347 21.2942C19.6966 21.1384 19.726 20.9715 19.721 20.8038C19.7161 20.6362 19.6769 20.4713 19.606 20.3193C19.535 20.1673 19.4337 20.0315 19.3084 19.9201L15.3575 16.0002L19.3084 12.039Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon_back.074ec3532027cd2933b8bb4dda5f7e0a.svg";
export { ForwardRef as ReactComponent };